"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./PromotionalPricing.scss");
var PromotionalPricing = /** @class */ (function (_super) {
    __extends(PromotionalPricing, _super);
    function PromotionalPricing(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isServer: true };
        return _this;
    }
    PromotionalPricing.prototype.componentDidMount = function () {
        this.setState({ isServer: false });
    };
    PromotionalPricing.prototype.render = function () {
        var _a = this.props, data = _a.data, options = _a.options;
        var strikePrice = data.strikePrice
            ? this.checkPrice(data.strikePrice)
                .toString()
                .split(".")
            : "";
        var price = data.price
            ? this.checkPrice(data.price)
                .toString()
                .split(".")
            : "";
        var pricingTypeClass = options && options.pricingType === "small" ? styles.priceSmall : styles.priceLarge;
        return (React.createElement("div", { className: pricingTypeClass + " " + (options && options.onDark ? "color-ui-white" : "color-ui-black") + " inline-block rel" },
            this.props.data.priceDescription && (React.createElement("div", { className: "type-base font-bold mar-b-xxs", "aria-hidden": "true" }, data.priceDescription)),
            strikePrice[0] && (React.createElement("span", { className: styles.previousPrice + " " + styles.withCents, "aria-hidden": "true" },
                strikePrice[0],
                strikePrice[1] && (React.createElement("span", { className: styles.previousCents }, strikePrice[1])))),
            React.createElement("span", { className: styles.currentPrice + " inline-flex font-bold", "aria-hidden": "true" },
                price[0] && React.createElement("span", { className: styles.priceAmount }, price[0]),
                price[1] && (React.createElement("span", { className: styles.priceAfter },
                    React.createElement("span", { className: styles.priceAfterTop }, price[1]),
                    React.createElement("span", { className: styles.priceDivider }),
                    React.createElement("span", { className: styles.priceAfterBottom }, data.billingNote ? data.billingNote : ""))),
                !price[1] && (React.createElement("span", { className: styles.priceAfter },
                    React.createElement("span", { className: styles.priceAfterBottom }, data.billingNote ? data.billingNote : ""),
                    React.createElement("span", { className: styles.priceDivider })))),
            this.props.data.discountDetails && (React.createElement("span", { className: "hidden-spoken type-xxl" }, data.discountDetails)),
            this.props.data.priceLegal && (React.createElement("div", { className: styles.priceLegal + " type-xxs" }, data.priceLegal))));
    };
    PromotionalPricing.prototype.checkPrice = function (priceVal) {
        var options = this.props.options;
        var decimalPoints = (options && options.decimalPoints) || 0;
        var price = priceVal || 0;
        if (typeof price === "string") {
            price = parseFloat(price);
            // console.log("price: ", parseFloat(price));
        }
        if (options && options.showAbsolute) {
            price = Number.isInteger(price) ? price : price.toFixed(2);
        }
        else if (decimalPoints > 0) {
            price = price.toFixed(decimalPoints);
        }
        // console.log("price: ", price)
        return price;
    };
    PromotionalPricing.defaultProps = {
        options: {
            className: "",
            showAbsolute: false,
            pricingType: "large",
            decimalPoints: 2,
        },
    };
    return PromotionalPricing;
}(React.Component));
exports.default = PromotionalPricing;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/PromotionalPricing/PromotionalPricing.js
// module id = 1850
// module chunks = 8